import clsx from 'clsx';
import React, { type FC, type ReactNode } from 'react';
import { Group } from 'react-resizable-panels';

import styles from './styles.module.css';

const Layout: FC<{
  children: ReactNode;
  disabled?: boolean;
  onLayoutChange?: (layout: Record<string, number>) => void;
}> = ({ children, disabled, onLayoutChange }) => (
  <Group
    autoSave="layout"
    className={clsx('main-container', styles.layout)}
    disabled={disabled}
    onLayoutChange={onLayoutChange}
    orientation="horizontal"
    id="main-scrollable-area"
  >
    {children}
  </Group>
);

export default Layout;
